import {
    getDataFormattata,
    getIconaStatoRelazione, getStatoMantenimentoVeicolo,
    getTimestampFormattato,
    STATO_RELAZIONE_BOZZA
} from "../../../../../utility/common";
import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import NsDataTable from "../../../../../components/tabelle/NsDataTable";

export default function TabellaRelazioniView({
                                                 relazioni,
                                                 isRuoloAdmin,
                                                 isRuoloCommissario,
                                                 certificato,
                                             }) {

    return (
        <NsDataTable
            data={relazioni}
            columns={[
                {
                    name: 'Data relazione',
                    selector: row => getTimestampFormattato(row.data_modifica),
                    sortable: true,
                },
                {
                    name: 'Certificato',
                    selector: row => (row.tipo_certificato || ''),
                    sortable: true,
                },
                {
                    name: 'Commissario',
                    selector: row => (row.nome || '') + ' ' + (row.cognome || ''),
                    sortable: true,
                },
                {
                    name: 'Ruolo',
                    selector: row => <Fragment>
                        {
                            row.codice_ruolo === 'ADMIN' &&
                            <div className={"rfi-evidence ns-bg--verde"}>
                                Amministratore
                            </div>
                        }
                        {
                            row.codice_ruolo === 'STAFF' &&
                            <div className={"rfi-evidence ns-bg--rosso"}>
                                Segreteria
                            </div>
                        }
                        {
                            row.codice_ruolo === 'COMM' &&
                            <div className={"rfi-evidence ns-bg--arancio"}>
                                Commissario
                            </div>
                        }
                        {
                            row.codice_ruolo === 'PRES' &&
                            <div className={"rfi-evidence ns-bg--verde"}>
                                Presidente
                            </div>
                        }
                        {
                            row.codice_ruolo === 'CONS' &&
                            <div className={"rfi-evidence ns-bg--giallo"}>
                                Conservatore
                            </div>
                        }
                    </Fragment>,
                    sortable: true,
                },
                {
                    name: 'Luogo visita',
                    selector: row => row.luogo,
                    sortable: true,
                },
                {
                    name: 'Data visita',
                    selector: row => getDataFormattata(row.data),
                    sortable: true,
                },
                {
                    name: 'Relazione',
                    selector: row => row.relazione,
                    sortable: true,
                },
                {
                    name: 'Stato',
                    selector: row => getIconaStatoRelazione(row),
                    sortable: true,
                },
                {
                    name: '',
                    selector: row => <Fragment>
                        {
                            row.stato == STATO_RELAZIONE_BOZZA
                            && (isRuoloAdmin() || isRuoloCommissario())
                            && parseInt(row.id_certificato) === parseInt(certificato.id_certificato) &&
                            <Link
                                to={"/upd-relazione/" + row.id_certificato + '/' + row.id_relazione_certificato}
                                className="btn btn-principal btn-sm"
                                data-toggle="tooltip" title="Modifica">
                                <i className="fas fa-pen"/>
                            </Link>
                        }
                    </Fragment>,
                    sortable: false,
                    right: true,
                    visible: () => certificato && (!certificato.id_doc_firmato || certificato.id_doc_firmato == '')
                }
            ]}
            addPagination={false}
            addFiltri={false}
            addDetail={true}
            getDettaglio={(el) => {
                return <Fragment>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            Relazione: <strong>{el.relazione || '-'}</strong>
                        </div>
                        <div className={"col-md-12"}>
                            Osservazioni: <strong>{el.osservazioni || '-'}</strong>
                        </div>

                        <div className={"col-md-4"}>
                            Stato del
                            veicolo: <strong>{getStatoMantenimentoVeicolo(el.stato_veicolo)}</strong>
                        </div>
                        <div className={"col-md-4"}>
                            Stato degli
                            interni: <strong>{getStatoMantenimentoVeicolo(el.stato_interni)}</strong>
                        </div>
                        <div className={"col-md-4"}>
                            Classificazione: <strong>{el.classificazione || '-'}</strong>
                        </div>
                    </div>
                </Fragment>;
            }}
        />
    );
}